import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const styles = createUseStyles(
  ({ colors, modal, spacing }: ITheme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      background: modal.backdropColor,
      zIndex: '10000',
    },
    modal: {
      padding: '32px',
      margin: spacing.large,
      maxWidth: '500px',
      width: '100%',

      borderRadius: 8,

      color: '#121212',
      background: colors.background,
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '38px',
    },
    title: {
      color: '#121212',
      fontWeight: FontWeight.Bold,
      fontSize: '20px',
      lineHeight: '28px',
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      gap: '12px',
    },
    description: {
      color: '#A0A0A3',
      fontSize: '16px',
      marginTop: '10px',
    },
    buttonsHolder: {
      alignSelf: 'flex-end',
      display: 'flex',
      gap: 16,
    },
  }),
  {
    name: 'confirmation-modal',
  },
);

export default styles;
